import { createPreTrialEmbeddedCheckoutSession } from '@/services/stripeService';
import {
	EmbeddedCheckoutProvider,
	EmbeddedCheckout
} from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useMemo } from 'react';

type StripeEmbedProps = {
	onComplete: () => void;
};

export const StripeEmbed = ({ onComplete }: StripeEmbedProps) => {
	const stripePromise = useMemo(
		() => loadStripe(String(process.env.STRIPE_PUBLIC_KEY)),
		[]
	);

	const handleFetchClientSecret = async () => {
		const { data } = await createPreTrialEmbeddedCheckoutSession();
		return data.data.clientSecret;
	};

	return (
		<div className="relative flex w-full overflow-hidden rounded-[1.25rem] lg:h-full lg:w-[24.5rem]">
			<div className="no-scrollbar bottom-0 left-0 right-0 top-0 grow overflow-auto !rounded-lg lg:absolute">
				<EmbeddedCheckoutProvider
					stripe={stripePromise}
					options={{
						fetchClientSecret: handleFetchClientSecret,
						onComplete
					}}
				>
					<EmbeddedCheckout />
				</EmbeddedCheckoutProvider>
			</div>
		</div>
	);
};
